window.addEventListener( 'DOMContentLoaded', function(){

    let bannerSlider = document.querySelectorAll('.banner-slider .splide');
    
    if(bannerSlider){
        for ( var i = 0; i < bannerSlider.length; i++ ) {
            
            let block = bannerSlider[ i ]; 
            
            let autoplay    = "true" == block.dataset.autoplay;
            let arrows      = "true" == block.dataset.arrows;
            let pagination  = "true" == block.dataset.pagination;
            
            // https://splidejs.com/guides/options/
            new Splide( block, {
                type   : 'loop',
                perPage: 1,
                perMove: 1,
                autoplay: autoplay,
                speed: 1400,
                pagination: pagination,
                arrows: arrows,
                arrowPath: 'm30.1945 21.9164c1.074-1.06 1.074-2.7812 0-3.8412l-16.4968-16.28026c-1.074-1.059919-2.8182-1.059919-3.89219 0-1.07401 1.05991-1.07401 2.78122 0 3.84112l14.55499 14.36394-14.5464 14.3641c-1.07401 1.0599-1.07401 2.781 0 3.841 1.074 1.0599 2.8182 1.0599 3.8922 0l16.4968-16.2803z',
            } ).mount();
        }
    }

} );